import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface FanGroup {
  id: number
  name: string
  count: number
  date_added: string
  default: number
}

interface FanGroupsCacheState {
  groups: FanGroup[]
  lastFetched: number | null
  setGroups: (groups: FanGroup[]) => void
  clear: () => void
}

export const useFanGroupsCacheStore = create<FanGroupsCacheState>()(
  persist(
    (set) => ({
      groups: [],
      lastFetched: null,
      setGroups: (groups) => set({ groups, lastFetched: Date.now() }),
      clear: () => set({ groups: [], lastFetched: null }),
    }),
    {
      name: 'fan-groups-cache',
      partialize: (state) => ({
        groups: state.groups,
        lastFetched: state.lastFetched,
      }),
    }
  )
)
